import BuildIcon from '@material-ui/icons/Build';

import List from './List';

export default {
  list: List,
  icon: BuildIcon,
};
